module.exports = __webpack_public_path__ + "img/vr_m_1.a1b6e444.jpg";